import React from "react";
import UseTitle from "../../Hooks/UseTitle";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import recreationCover from "../../../Assets/Hompage/Recreation/recreation-cover.jpeg";
import recreationCoverMobile from "../../../Assets/recreationmobile.jpg";
import recreation from "../../../Assets/Hompage/Recreation/recreation (3).jpeg";
import recreation1 from "../../../Assets/Hompage/Recreation/recreation (1).jpeg";
import recreation2 from "../../../Assets/Hompage/Recreation/recreation (2).jpeg";
const Recreation = () => {
  UseTitle("Recreation");
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <div>
      <div className="bg-gray-100">
        <div className="pt-16 md:pt-0 md:block hidden">
          <img src={recreationCover} alt="Recreation" className="w-full" />
        </div>
        <div className="pt-16 md:pt-0 md:hidden block">
          <img
            src={recreationCoverMobile}
            alt="Recreation"
            className="w-full"
          />
        </div>
        <div className="max-w-screen-xl mx-auto">
          <div className="py-10 md:px-20 px-5 bg-white " data-aos="zoom-in">
            <h2 className="text-[50px] text-gray-800 text-center md:text-start">
              Recreation
            </h2>

            <div className="py-20">
              <p className="text-[16px]">
                You’ll find our beautiful recreational area, where you can take
                a break from the hustle and bustle of everyday life and enjoy
                some time surrounded by nature. We have a range of seating
                options available for you to relax and take in the stunning
                scenery. Also, you can sit on one of our benches located right
                beside the water and enjoy the sound of the gently lapping waves
                or the singing of the birds in the trees. We have a swing
                located right beside the lake that offers a thrilling and
                enjoyable ride while taking in the serene beauty of the
                surrounding nature.
              </p>
            </div>
          </div>

          <div className="px-5 md:px-0">
            <Carousel
              responsive={responsive}
              infinite={true}
              autoPlaySpeed={2000}
              autoPlay={true}
              customTransition="all .5"
            >
              <div>
                <img src={recreation} alt="" className="w-full" />
              </div>
              <div>
                <img src={recreation1} alt="Recreation" className="w-full" />
              </div>

              <div>
                <img src={recreation2} alt="Recreation" className="w-full" />
              </div>
              <div>
                <img src={recreation} alt="Recreation" className="w-full" />
              </div>
            </Carousel>
          </div>
          <div className="py-20">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
              <div className="flex justify-center items-start"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recreation;
